import { Component, Output, EventEmitter, ViewEncapsulation } from '@angular/core'
import { NGXLogger } from 'ngx-logger'
//import { SharedDataService } from 'src/app/services/shared-data.service'


@Component({
    selector: 'web-prequal-security',
    templateUrl: './web-prequal-security.component.html',
    styleUrls: ['./web-prequal-security.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class WebPreQualSecurityComponent {
  constructor(
     public logger: NGXLogger,
    // public sharedDataService: SharedDataService
  ) { }

  @Output() closeFooterSecurity: EventEmitter<any> = new EventEmitter()
  @Output() closed: EventEmitter<unknown> = new EventEmitter()

  close() {
    this.closed.emit(true)
  }

  public async closeSecurity(){
   this.closeFooterSecurity.emit()
  }

}
